import React from 'react';
import { Package } from 'lucide-react';
import Badge from '../ui/Badge';
import { SupplyProductAllocation } from '../../types';

interface AllocationBadgesProps {
  allocations: SupplyProductAllocation[];
  maxVisible?: number;
  compact?: boolean;
}

const AllocationBadges: React.FC<AllocationBadgesProps> = ({
  allocations,
  maxVisible = 2,
  compact = false
}) => {
  if (allocations.length === 0) {
    return null;
  }

  const visibleAllocations = allocations.slice(0, maxVisible);
  const remainingCount = allocations.length - maxVisible;

  return (
    <div className={`${compact ? 'p-2' : 'p-3'} bg-blue-50 rounded-lg border border-blue-200`}>
      <div className="flex items-start gap-2">
        <Package className="h-4 w-4 text-blue-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="text-xs font-medium text-blue-900 mb-1.5">
            Used in {allocations.length} product{allocations.length !== 1 ? 's' : ''}:
          </div>
          <div className="flex items-center gap-1.5 flex-wrap">
            {visibleAllocations.map((allocation) => {
              const product = allocation.manufactured_product;

              if (!product) {
                console.warn('Allocation missing product data:', allocation);
                return (
                  <Badge
                    key={allocation.id}
                    variant="secondary"
                    className="text-xs"
                  >
                    Unknown Product
                  </Badge>
                );
              }

              const statusColor =
                product.status === 'production' ? 'success' :
                product.status === 'prototype' ? 'warning' :
                product.status === 'design' ? 'secondary' :
                'secondary';

              return (
                <Badge
                  key={allocation.id}
                  variant={statusColor}
                  className="text-xs"
                >
                  {product.name || 'Unnamed Product'}
                </Badge>
              );
            })}
            {remainingCount > 0 && (
              <span className="text-xs font-medium text-blue-700 whitespace-nowrap">
                +{remainingCount} more
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllocationBadges;
